import { AuthenticationRepository } from "@src/cloud-connect/node-manager/authentication/authentication-repository";

export class AuthenticationBodyBuilder {
  private authenticationRepository: AuthenticationRepository;

  constructor(authenticationRepository: AuthenticationRepository) {
    this.authenticationRepository = authenticationRepository;
  }

  private buildBodyObject(customerNamespace) {
    return {
      customerNamespace: customerNamespace,
    };
  }

  public build() {
    return this.buildBodyObject(
      this.authenticationRepository.getCustomerNamespace(),
    );
  }
}
